import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { filterTabsData } from "@sunSource/Common/Utilities/TabsFilterUtils";
import { CustomApiHandler } from "@sunSource/Store/CustomHandlerCreator";
import sortBy from "lodash/sortBy";

type HandlerType = CustomApiHandler<{ activeTab: string | "", tabsSearchTerm?: string | "", tagsName?: string | "" }>;
const normalize = (value?: string) => value?.trim().toLowerCase() ?? "";

export const DispatchActiveTabNewslistData: HandlerType = async props => {
    const stateData = props.getState();

    // Get all pages under the current page and filter by active tab category, then sort by publish date
    const pages = getDataView(stateData.data.pages, { parentNodeId: getCurrentPage(stateData).nodeId });
    const { value } = pages;
    const sortedAndPagedPages = (value?.length ?? 0) > 0 ? sortBy(value, o => o.fields["publishDate"]).reverse() : []; 

    // If activeTab is empty, it means "All" tab is selected, so we show all pages. Otherwise, filter by categoryListName matching the active tab.
    const currentTabData = sortedAndPagedPages.filter(page => page.generalFields["categoryListName"].trim().toLowerCase() === props.parameter.activeTab.trim().toLowerCase());
    props.dispatch({
        type: "Custom/TabsDataState/listActiveTab",
        listActiveTabData: currentTabData,
    });
};

export const DispatchTabsActiveStatus: HandlerType = props => {
    props.dispatch({
        type: "Custom/TabsDataState/active",
        activeTab: props.parameter.activeTab,
    });
};

export const DispatchTabsSearchTermRemove: HandlerType = props => {
    if (props.parameter.tabsSearchTerm === "") {
        props.dispatch({
            type: "Custom/TabsDataState/removeSearchTerm",
            tabsSearchTerm: props.parameter.tabsSearchTerm, // if the parameter is empty string, it means user is trying to clear the search term, so we want to set it to empty string. But if the parameter is undefined, we want to keep the current search term in the state.
        });
    }
};


export const DispatchTagsNameRemove: HandlerType = props => {
    if (props.parameter.tagsName !== undefined) {
        props.dispatch({
            type: "Custom/TabsDataState/removeTagName",
            tagsName: props.parameter.tagsName, // if the parameter is empty string, it means user is trying to clear the tag filter, so we want to set it to empty string. But if the parameter is undefined, we want to keep the current tag name in the state.   
        });
    }
};

export const dispatchTabsItemListUpdate: HandlerType = props => {
    const state = props.getState();

    const searchTerm = normalize(props.parameter.tabsSearchTerm || state.sunSourceState.TabsActiveData.tabsSearchTerm) || "";

    const tags = state.sunSourceState.TabsActiveData.tagsName;

    const activeTabData = state.sunSourceState.TabsActiveData.listActiveTabData;

    const pages = getDataView(state.data.pages, { parentNodeId: getCurrentPage(state).nodeId });
    const sortedAndPagedPages = (pages?.value?.length ?? 0) > 0 ? sortBy(pages.value, o => o.fields["publishDate"]).reverse() : [];

    const data = activeTabData?.length ? activeTabData : sortedAndPagedPages ?? [];

    const filteredData = filterTabsData(data, searchTerm, tags, state);

    props.dispatch({
        type: "Custom/TabsDataState/listActiveTab",
        listActiveTabData: filteredData,
    });
};

export const chain = [DispatchActiveTabNewslistData, DispatchTabsActiveStatus, DispatchTabsSearchTermRemove, DispatchTagsNameRemove, dispatchTabsItemListUpdate];

const TabTagSearchQueryRemoveHandler = createHandlerChainRunner(chain, "TabTagSearchQueryRemove");
export default TabTagSearchQueryRemoveHandler;
